export const serie_padrao = [
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
];
